import { useLocation, useNavigate } from "react-router-dom";
import type {
  PartialLocation,
  QueryParamAdapterComponent,
} from "use-query-params";

/**
 * Adapter for use-query-params with React Router v7+.
 * The package's `react-router-6` adapter relies on RR6-era internals; this
 * uses stable `useLocation` / `useNavigate` (see use-query-params#295).
 */
export const ReactRouterQueryParamAdapter: QueryParamAdapterComponent = ({
  children,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return children({
    location,
    replace: (next: PartialLocation) => {
      navigate(next.search || "?", {
        replace: true,
        state: next.state,
      });
    },
    push: (next: PartialLocation) => {
      navigate(next.search || "?", {
        replace: false,
        state: next.state,
      });
    },
  });
};
